var OrderInfoStore = reactive({
  orderInfo: null,
  cartInfo: null,
  productDiscountsAmount: 0,
  shippingMethodDates: null,
  isAfterPay: false,
  setIsAfterPay: function setIsAfterPay() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.isAfterPay = state;
  },
  setShippingMethodDates: function setShippingMethodDates(methods) {
    this.shippingMethodDates = methods;
  },
  addProductDiscountsAmount: function addProductDiscountsAmount(centAmount) {
    this.productDiscountsAmount += centAmount;
  },
  setCartInfo: function setCartInfo(cart) {
    this.cartInfo = cart;
  },
  setOrderInfo: function setOrderInfo(order) {
    this.orderInfo = order;
  },
  clear: function clear() {
    this.orderInfo = null;
  }
});
export { OrderInfoStore };